module.exports = __webpack_public_path__ + "static/img/CycleAI logo black.4e67cbe.png";